import React, { useEffect, useRef,useState } from 'react';
import { HomeOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import Message from '../../component/message/message';//提示信息弹框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import './dashboard.css';
import { useHistory } from 'react-router-dom';
import * as echarts from 'echarts/core';
import * as barCharts from 'echarts/core';
import { TitleComponent, TooltipComponent, GridComponent, LegendComponent, MarkLineComponent, MarkPointComponent } from 'echarts/components';
import { LineChart, BarChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
const { Option } = Select;

echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent,
    MarkLineComponent,
    MarkPointComponent,
    LineChart,
    CanvasRenderer,
    UniversalTransition,
]);
barCharts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent,
    MarkLineComponent,
    MarkPointComponent,
    BarChart,
    CanvasRenderer,
    UniversalTransition,
])


const Dashboard = (props) => {

    const messageRef = useRef();
    const history = useHistory();
    const [searchModel, setSearchModel] = useState({});
    const [searchACTModel, setSearchACTModel] = useState({});
    const [searchModuleModel, setSearchModuleModel] = useState({});
    const [progList, setProgList] = useState([]);
    const [progCode, setProgCode] = useState("");
    const [progCodeACT, setProgCodeACT] = useState("");
    const progCodeRef = useRef();
    const progCodeACTRef = useRef();
    useEffect(() => {
        search();
        searchAllProgramme()
        searchACT();
        searchModule();
    }, []);

    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newSearchModel => {
            return { ...newSearchModel, ...{ [k]: e } };
        })
        progCodeRef.current = e
        search(e)
    }

    const searchChangeModule = (k, e) => {
        messageShowHandler();
        setSearchModuleModel(newSearchModel => {
            return { ...newSearchModel, ...{ [k]: e } };
        })
        searchModule(e)
    }

    const searchChangeACT = async(k, e) => {
        messageShowHandler();
        setSearchACTModel(newSearchModel1 => {
            return { ...newSearchModel1, ...{ [k]: e } };
        })
        progCodeACTRef.current = e
        searchACT(e)
    }

    const searchAllProgramme = () => {
        let model = {};
        model.progCodeList = Config.userInfo?.progCodeList;
        Base.callBackApi("commonDropDown/searchAllProgramme", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                var list = data?.object ?? []
                var newList = list.filter(item => item.progCode != "UNCERTAIN")
                setProgList(newList);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const searchACT = (programme) => {
        let model ={}
        model.progCodeACT = programme;
        model.progCode = searchModel.progCode
        model.progCodeList = Config.userInfo?.progCodeList;
        messageShowHandler()
        Base.callBackApi("dashboard/search",model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let map = new Map();
                let list = data.object?.totalJobPost ?? []
                let list2 = data.object?.totalJobAppl ?? []
                let list3 = data.object?.totalRoleLogin ?? []
                let deptList = [];
                let activeJobPostNumList = [];
                let submitJobPostNumList = [];
                let teacherReviewingJobApplNumList = []
                let offerJobApplNumList = []
                let roleNameList = []
                let roleLoginList = []

                for (let i = 0; i < list.length; i++) {
                    deptList.push(list[i].deptDisplayName);
                    activeJobPostNumList.push(list[i].activeJobPostNum)
                    submitJobPostNumList.push(list[i].submitJobPostNum)
                    teacherReviewingJobApplNumList.push(list2[i].teacherReviewingJobApplNum)
                    offerJobApplNumList.push(list2[i].offerJobApplNum)
                }
                for (let i = 0; i < list3.length; i++) {
                    roleNameList.push(list3[i].roleName);
                    roleLoginList.push(list3[i].roleLoginNum)
                }
                map.set("deptList", deptList);
                map.set("activeJobPostNumList", activeJobPostNumList);
                map.set("submitJobPostNumList", submitJobPostNumList);
                map.set("teacherReviewingJobApplNumList", teacherReviewingJobApplNumList);
                map.set("offerJobApplNumList", offerJobApplNumList);
                map.set("roleNameList", roleNameList);
                map.set("roleLoginList", roleLoginList);
                getData(map)
                getDataActionsPending(map)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    //查询
    const search = (programme) => {
        let model ={}
        model.progCode = programme;
        model.progCodeList = Config.userInfo?.progCodeList;
        messageShowHandler()
        Base.callBackApi("dashboard/search",model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let map = new Map();
                let list = data.object?.totalJobPost ?? []
                let list2 = data.object?.totalJobAppl ?? []
                let list3 = data.object?.totalRoleLogin ?? []
                let deptList = [];
                let activeJobPostNumList = [];
                let submitJobPostNumList = [];
                let teacherReviewingJobApplNumList = []
                let offerJobApplNumList = []
                let roleNameList = []
                let roleLoginList = []

                for (let i = 0; i < list.length; i++) {
                    deptList.push(list[i].deptDisplayName);
                    activeJobPostNumList.push(list[i].activeJobPostNum)
                    submitJobPostNumList.push(list[i].submitJobPostNum)
                    teacherReviewingJobApplNumList.push(list2[i].teacherReviewingJobApplNum)
                    offerJobApplNumList.push(list2[i].offerJobApplNum)
                }
                for (let i = 0; i < list3.length; i++) {
                    roleNameList.push(list3[i].roleName);
                    roleLoginList.push(list3[i].roleLoginNum)
                }
                map.set("deptList", deptList);
                map.set("activeJobPostNumList", activeJobPostNumList);
                map.set("submitJobPostNumList", submitJobPostNumList);
                map.set("teacherReviewingJobApplNumList", teacherReviewingJobApplNumList);
                map.set("offerJobApplNumList", offerJobApplNumList);
                map.set("roleNameList", roleNameList);
                map.set("roleLoginList", roleLoginList);
                getData(map)
                getDataKeyStatistics(map,programme)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    //查询
    const searchModule = (programme) => {
        let model ={}
        model.progCode = programme;
        model.progCodeList = Config.userInfo?.progCodeList;
        messageShowHandler()
        Base.callBackApi("dashboard/searchModule",model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let map = new Map();
                let list = data.object ?? []
                let deptList = [];
                let activeStudentModuleNumList = [];
                let holdStudentModuleNumList = [];
                let activeModuleNumList = [];
                for (let i = 0; i < list.length; i++) {
                    deptList.push(list[i].deptDisplayName);
                    activeStudentModuleNumList.push(list[i].activeStudentModuleNum)
                    holdStudentModuleNumList.push(list[i].holdStudentModuleNum)
                    activeModuleNumList.push(list[i].activeModuleNum)
                }
                map.set("deptList", deptList);
                map.set("activeStudentModuleNumList", activeStudentModuleNumList);
                map.set("holdStudentModuleNumList", holdStudentModuleNumList);
                map.set("activeModuleNumList", activeModuleNumList);
                getDataModule(map);
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const getData = (dataMap) => {
        let map = new Map(dataMap);
        //过去七天每个role登录次数
        let studentsChart = echarts.init(document.getElementById('students'), 'light');
        studentsChart.setOption({
            yAxis: {
                type: 'category', // 将 y 轴类型改为 category
                data: map.get('roleNameList'),
            },
            xAxis: {
                type: 'value' // 将 x 轴类型改为 value
            },
            series: [
                {
                    name: '',
                    type: 'bar',
                    color: '#0059AC',
                    data: map.get('roleLoginList'),
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: function (params) {
                            if (params.value === 0) {
                                return ''; // 当值为 0 时返回空字符串，不显示 0
                            } else {
                                return params.value;
                            }
                        }
                    }
                },
            ]

        });
    }

    const getDataKeyStatistics = (dataMap) => {
        let map = new Map(dataMap);
        let academicStaffChart = barCharts.init(document.getElementById('inbound'), 'light');
        academicStaffChart.setOption({
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            legend: {},
            xAxis: {
                type: 'category',
                data: map.get('deptList'),
                axisLabel: {
                    formatter: function (value) {
                        return value.replace(/(\S+\s)/g, '$1\n');
                    }
                }
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}'
                }
            },
            series: [
                {
                    name: 'Total of Active Job Posts',
                    type: 'bar',
                    color: '#0059AC',
                    data: map.get('activeJobPostNumList'),
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: function (params) {
                            if (params.value === 0) {
                                return ''; // 当值为 0 时返回空字符串，不显示 0
                            } else {
                                return params.value;
                            }
                        }
                    }
                },
                {
                    name: 'Total of Active Enrolled Students',
                    type: 'bar',
                    color: '#008B00',
                    data: [0, 0, 0, 0, 0, 0],
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: function (params) {
                            if (params.value === 0) {
                                return ''; // 当值为 0 时返回空字符串，不显示 0
                            } else {
                                return params.value;
                            }
                        }
                    }
                },
            ]
        });
        academicStaffChart.on('click', function (params) {
            let model = {
                columnName: params.seriesName,
                eptName: params.name,
                progCode:progCodeRef.current
            }
            if (model.columnName === "Total of Active Job Posts") {
                model.jobPostStatus = "ACTIVE";
                jump(model, "/main/jobManagement")
            }
        });
    }

    const getDataActionsPending = (dataMap) => {
        let map = new Map(dataMap);
        let wpaChart = barCharts.init(document.getElementById('wpaChart'), 'light');
        wpaChart.setOption({
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            legend: {},
            xAxis: {
                type: 'category',
                data: map.get('deptList'),
                axisLabel: {
                    formatter: function (value) {
                        // 根据需要对 X 轴的标签进行换行处理
                        // 例如，每隔一定长度添加换行符
                        return value.replace(/(\S+\s)/g, '$1\n');
                    }
                }
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}'
                }
            },
            series: [
                {
                    name: 'Pending Job Post Review',
                    type: 'bar',
                    color: '#0059AC',
                    data: map.get('submitJobPostNumList'),
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: function (params) {
                            if (params.value === 0) {
                                return ''; // 当值为 0 时返回空字符串，不显示 0
                            } else {
                                return params.value;
                            }
                        }
                    }
                },
                {
                    name: 'Pending Job Application Review',
                    type: 'bar',
                    color: '#008B00',
                    data: map.get('teacherReviewingJobApplNumList'),
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: function (params) {
                            if (params.value === 0) {
                                return ''; // 当值为 0 时返回空字符串，不显示 0
                            } else {
                                return params.value;
                            }
                        }
                    }
                },
                {
                    name: 'Pending Student Response to Job Offers',
                    type: 'bar',
                    color: '#D71920',
                    data: map.get('offerJobApplNumList'),
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: function (params) {
                            if (params.value === 0) {
                                return ''; // 当值为 0 时返回空字符串，不显示 0
                            } else {
                                return params.value;
                            }
                        }
                    }
                },
            ]
        });
        wpaChart.on('click', function (params) {
            let model = {
                columnName: params.seriesName,
                eptName: params.name,
                progCode : progCodeACTRef.current
            }
            let path = ""
            switch (model.columnName) {
                case "Pending Job Post Review":
                    path = "/main/jobManagement"
                    model.jobPostStatus = "SUBMITTED" 
                    break;

                case "Pending Job Application Review":
                    path = "/main/jobApplicationRecord"
                    model.jobApplStatus = "TEACHER_REVIEWING"
                    break;
                case "Pending Student Response to Job Offers":
                    path = "/main/jobApplicationRecord"
                    model.jobApplStatus = "OFFER"
                    break;
            }
            jump(model, path)
        });
    }

    const getDataModule = (dataMap) => {
        let map = new Map(dataMap);
        let moduleChart = barCharts.init(document.getElementById('moduleChart'), 'light');
        moduleChart.setOption({
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            legend: {},
            xAxis: {
                type: 'category',
                data: map.get('deptList'),
                axisLabel: {
                    formatter: function (value) {
                        // 根据需要对 X 轴的标签进行换行处理
                        // 例如，每隔一定长度添加换行符
                        return value.replace(/(\S+\s)/g, '$1\n');
                    }
                }
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}'
                }
            },
            series: [
                {
                    name: '# of Active Module',
                    type: 'bar',
                    color: '#0059AC',
                    data: map.get('activeModuleNumList'),
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: function (params) {
                            if (params.value === 0) {
                                return ''; // 当值为 0 时返回空字符串，不显示 0
                            } else {
                                return params.value;
                            }
                        }
                    }
                },
                {
                    name: '# Active Enrolled-Module-Students',
                    type: 'bar',
                    color: '#008B00',
                    data: map.get('activeStudentModuleNumList'),
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: function (params) {
                            if (params.value === 0) {
                                return ''; // 当值为 0 时返回空字符串，不显示 0
                            } else {
                                return params.value;
                            }
                        }
                    }
                },
                {
                    name: '# of Hold WIL Student',
                    type: 'bar',
                    color: '#D71920',
                    data: map.get('holdStudentModuleNumList'),
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: function (params) {
                            if (params.value === 0) {
                                return ''; // 当值为 0 时返回空字符串，不显示 0
                            } else {
                                return params.value;
                            }
                        }
                    }
                },
            ]
        });
    }

    const jump = (model, path) => {
        history.push({
            pathname: path,
            model: model,
        });
    };

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    return (
        <div id="container" className="template">
            {Base.isEmpty(Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]) ? ""
                :
                <div className='breadcrumb'>
                    <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
                </div>
            }
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='dashboardMain'>
                <div className='dashboardRow'>
                    <div className="dashboardRowTitle">Number of logged in roles in the past seven days</div>
                    <div className='newDiv'>
                        <div className='dashboardBox'>
                            <div className='dashboardEchartsRow'>
                                <div id="students" className="dashboardEcharts2"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='dashboardRow'>
                    <div style={{display:'flex',backgroundColor:'#FFF',justifyContent:'space-between'}}>
                        <div className="dashboardRowTitle">Overview - Assessment</div>
                        <div style={{display:'flex'}}>
                            <div className="dashboardRowTitle" style={{paddingTop:'15px',paddingRight:'0px',fontWeight:'normal'}}>Programme</div>
                            <div className="sysSerchInput" style={{paddingTop:'5px',paddingRight:'10px'}}>
                                    <Select className="sysSelect" placeholder="Programme"
                                        value={searchModuleModel.progCode || ''}
                                        onChange={(e) => searchChangeModule('progCode', e)}
                                        >
                                    <Option value=""></Option>
                                    {progList.map((item) => <Option key={item.progCode} value={item.progCode}>{item.progTitle}</Option>)}
                                </Select>
                            </div>
                        </div>
                    </div>
                    <div className='newDiv'>
                        <div className='dashboardBox'>
                            <div className='dashboardEchartsRow'>
                                <div id="moduleChart" className="dashboardEcharts"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='dashboardRow'>
                    <div style={{display:'flex',backgroundColor:'#FFF',justifyContent:'space-between'}}>
                        <div className="dashboardRowTitle">Overview - Job</div>
                        <div style={{display:'flex'}}>
                            <div className="dashboardRowTitle" style={{paddingTop:'15px',paddingRight:'0px',fontWeight:'normal'}}>Programme</div>
                            <div className="sysSerchInput" style={{paddingTop:'5px',paddingRight:'10px'}}>
                                    <Select className="sysSelect" placeholder="Programme"
                                        value={searchModel.progCode || ''}
                                        onChange={(e) => searchChange('progCode', e)}
                                        >
                                    <Option value=""></Option>
                                    {progList.map((item) => <Option key={item.progCode} value={item.progCode}>{item.progTitle}</Option>)}
                                </Select>
                            </div>
                        </div>

                    </div>
                    
                    <div className='newDiv'>
                        <div className='dashboardBox'>
                            <div className='dashboardEchartsRow'>
                                <div id="inbound" className="dashboardEcharts"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='dashboardRow'>
                    <div style={{display:'flex',backgroundColor:'#FFF',justifyContent:'space-between'}}>
                        <div className="dashboardRowTitle">Actions Pending</div>
                        <div style={{display:'flex'}}>
                            <div className="dashboardRowTitle" style={{paddingTop:'15px',paddingRight:'0px',fontWeight:'normal'}}>Programme</div>
                            <div className="sysSerchInput" style={{paddingTop:'5px',paddingRight:'10px'}}>
                                    <Select className="sysSelect" placeholder="Programme"
                                        value={searchACTModel.progCode || ''}
                                        onChange={(e) => searchChangeACT('progCode', e)}
                                        >
                                    <Option value=""></Option>
                                    {progList.map((item) => <Option key={item.progCode} value={item.progCode}>{item.progTitle}</Option>)}
                                </Select>
                            </div>
                        </div>
                    </div>
                    <div className='newDiv'>
                        <div className='dashboardBox'>
                            <div className='dashboardEchartsRow'>
                                <div id="wpaChart" className="dashboardEcharts"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Dashboard;